import type { View } from "../lib";

const views: Array<{ id: View; label: string }> = [
  { id: "brief", label: "晨报" },
  { id: "feed", label: "信号流" },
  { id: "matrix", label: "信号矩阵" },
];

export function ViewSwitcher({ value, onChange }: { value: View; onChange: (view: View) => void }) {
  return (
    <div className="view-switcher" role="tablist" aria-label="市场信号视图">
      {views.map((view) => (
        <button
          className={value === view.id ? "is-active" : ""}
          key={view.id}
          onClick={() => onChange(view.id)}
          role="tab"
          aria-selected={value === view.id}
          type="button"
        >
          {view.label}
        </button>
      ))}
    </div>
  );
}
